export const actionTypes = {
  FOLDER_ADD_DATA_PACKAGE: 'FOLDER_ADD_DATA_PACKAGE',
  FOLDER_CREATE: 'FOLDER_CREATE',
  FOLDER_DELETE: 'FOLDER_DELETE',
  FOLDER_REMOVE_DATA_PACKAGE: 'FOLDER_REMOVE_DATA_PACKAGE',
  FOLDER_RESET: 'FOLDER_RESET',
  FOLDER_SET_DATA: 'FOLDER_SET_DATA',
  FOLDER_SET_MODE: 'FOLDER_SET_MODE',
  FOLDER_UPDATE: 'FOLDER_UPDATE',
  FOLDER_VIEW: 'FOLDER_VIEW',
  FOLDER_SET_DATA_PACKAGES_FROM_ENTRY: 'FOLDER_SET_DATA_PACKAGES_FROM_ENTRY',
  FOLDER_SET_DATA_PACKAGES_FROM_ENTRY_DONE: 'FOLDER_SET_DATA_PACKAGES_FROM_ENTRY_DONE',
  FOLDER_CLEAR_DATA_PACKAGES_FROM_ENTRY: 'FOLDER_CLEAR_DATA_PACKAGES_FROM_ENTRY',
  FOLDER_ADD_DATA_PACKAGES_FROM_ENTRY_TO_FOLDER: 'FOLDER_ADD_DATA_PACKAGES_FROM_ENTRY_TO_FOLDER',
  STOREFRONT_ADD_SHELF: 'STOREFRONT_ADD_SHELF',
  STOREFRONT_CREATE: 'STOREFRONT_CREATE',
  STOREFRONT_REMOVE_SHELF: 'STOREFRONT_REMOVE_SHELF',
  STOREFRONT_RESET: 'STOREFRONT_RESET',
  STOREFRONT_SET_DATA: 'STOREFRONT_SET_DATA',
  STOREFRONT_SET_MODE: 'STOREFRONT_SET_MODE',
  STOREFRONT_UPDATE: 'STOREFRONT_UPDATE',
  ALIAS_DELETE: 'ALIAS_DELETE',
  ALIAS_DELETE_DONE: 'ALIAS_DELETE_DONE',
  ALIAS_ADD: 'ALIAS_ADD',
  ALIAS_ADD_DONE: 'ALIAS_ADD_DONE',
};
